import MARKET_TYPE from 'constants/marketType'

export const ROUTES_MAX_NUMBER = 30

export const ROUTE_FILTERS = {
  [MARKET_TYPE.CABOTAGE]: { countries: ['ar'] },
  [MARKET_TYPE.REGIONAL]: { regions: ['soa'], baseOnSiblingExclude: ['countryCode'] },
  [MARKET_TYPE.INTERNATIONAL]: {
    countries: ['ar'],
    regions: ['sea', 'sas', 'soa', 'noa', 'mde', 'jak', 'eur', 'cem', 'car', 'afr'],
    baseOnSiblingExclude: ['countryCode', 'region']
  }
}

export const CAPITAL_FEDERAL_PROVINCE = 'CABA'
